import React from 'react';
import {
    IntlProvider,
    addLocaleData,
} from 'react-intl';

import en from 'react-intl/locale-data/en';
import de from 'react-intl/locale-data/de';

addLocaleData([...en, ...de]);

const withIntl = (WrappedComponent) => {
    return class WithIntl extends React.Component {
        render() {
            return (
                <IntlProvider locale={navigator.language}>
                    <WrappedComponent {...this.props} />
                </IntlProvider>
            );
        }
    };
};

export default withIntl;